<template>
  <div class="mit-reserve-now">
        <v-snackbar top :color="status.color" min-width="0" v-model="status.display" :timeout="status.timeout">
            <b>{{ status.message }}</b>
        </v-snackbar>
        <v-dialog v-model="dialogExistingReservation" width="600">
            <v-card flat v-if="selectedReservationExisting">
                <v-card-title class="text-h7 grey lighten-2">
                    <!-- <span style="width: 450px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"><v-icon class="pr-3">mdi-calendar</v-icon>{{ selectedReservationExisting.name }}</span> -->
                    <v-icon class="pr-3">mdi-calendar</v-icon>
                    Event Details
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-1" elevation="0" fab small @click="dialogExistingReservation=false"><v-icon>mdi-close-circle-outline</v-icon></v-btn>
                </v-card-title>
                <BaseMitReservationReadOnly class="pa-3" :reservation="selectedReservationExisting"/>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogSpaceImages" max-width="600px">
                            <v-card flat v-if="dialogSelectedSpace">
                                <v-toolbar flat dense color="grey lighten-1">
                                    <span><b>{{dialogSelectedSpace.nameFormatted}}</b></span>
                                    <v-spacer></v-spacer>
                                    <v-btn color="grey lighten-1" elevation="0" fab small @click="dialogSpaceImages=false"><v-icon>mdi-close-circle-outline</v-icon></v-btn>
                                </v-toolbar>
                                <v-carousel>
                                    <v-carousel-item
                                    v-for="(item,i) in dialogSelectedSpace.images"
                                    :key="i"
                                    :src="spacesUrl+'/images/'+item"
                                    reverse-transition="fade-transition"
                                    transition="fade-transition"
                                    ></v-carousel-item>
                                </v-carousel>
                            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogSpaceDetails" max-width="600px">
        <v-card flat v-if="dialogSelectedSpace">
            <v-toolbar flat dense color="grey lighten-1">
                <span><b>{{dialogSelectedSpace.nameFormatted}}</b></span>
                <v-spacer></v-spacer>
                <v-btn color="grey lighten-1" elevation="0" fab small @click="dialogSpaceDetails=false"><v-icon>mdi-close-circle-outline</v-icon></v-btn>
            </v-toolbar>

            <v-card-text>
                <div class="pt-2"><b>ID:</b> {{dialogSelectedSpace.mitId}}</div>
                <div><b>Description:</b><br> {{dialogSelectedSpace.description}}</div>
                <div><b>Location</b>
                    <a style="text-decoration: none;" target="_blank" rel="noopener noreferrer" :href="spacesUrl+'/maps/'+dialogSelectedSpace.buildingMitId+'?s='+dialogSelectedSpace.mitId+'&l='+dialogSelectedSpace.level">
                        <v-icon class="pl-3" color="primary">mdi-map-marker</v-icon>Open Maps
                    </a>
                </div>
                <div v-if="dialogSelectedSpace.spaceType == 'space'">
                    <div><b>Organization:</b> {{dialogSelectedSpace.org}}</div>
                    <div><b>Area (sqfoot):</b> {{dialogSelectedSpace.sqfoot}}</div>
                </div>
                <div><b>Type:</b> {{dialogSelectedSpace.useType}}</div>
                <div v-if="dialogSelectedSpace.equipment && dialogSelectedSpace.equipment.length > 0"><b>Equipment:</b><br>{{dialogSelectedSpace.equipment}}</div>
                <div v-if="dialogSelectedSpace.maxCapacity"><b>Person Capacity:</b> {{dialogSelectedSpace.maxCapacity}}</div>
                <div class="pb-5" v-if="dialogSelectedSpace.seating && dialogSelectedSpace.seating.length > 0"><b>Seating:</b> {{dialogSelectedSpace.seating}}</div>
                <a href="https://tig.csail.mit.edu/events-reservations/" target="_blank">See the TIG Events, Rooms, and Video Conference page for more info</a>
            </v-card-text>
        </v-card>
        </v-dialog>
      <BaseMitLoading :show="loadingReservations || loadingSpaces || loadingSave || loadingDelete" :overlayFullscreen="false"/>
      <!-- New RESERVATION so its ok to pass it in -->
      <BaseMitReserveEdit :show="dialog" :existingReservation="reservation" :allSpaces="spaces" :selectedSpace="selectedSpace" @cancel="cancelReservation" @delete="deleteReservation" @save="saveReservation"/>
      <!-- EXISTING, so we should always pass in the id to look it up, in the case of an out of date entry, lets always get the latest  -->
      <BaseMitReserveEdit :show="dialogEdit" :existingReservationUniqueId="selectedReservationExistingId" :allSpaces="spaces" @cancel="cancelReservation" @delete="deleteReservation" @save="saveReservation"/>
      
      <v-card flat>
          <v-row class="pl-2 pr-2">
            <v-col cols="12">
                <v-row>
                      <v-col cols="12" class="pa-0">
                        <MitCalendarMultiSpaces
                            v-if="spaces.length > 0"
                            ref="calMultiSpaces"
                            :userModel="userModel"
                            :focusTime="reservation.startTime"
                            :calendarDate="reservation.startDate"
                            :events="calEvents"
                            :spacesList="spaces"
                            :spaceInfo="spaceInfo"
                            @create="newReservation"
                            @favoriteChanged="favoriteChanged"
                            @change="calendarChange"
                            @showSpaceImages="showSpaceImages"
                            @showExistingReservationDetails="showExistingReservationDetails"
                            @showSpaceDetails="showSpaceDetails"
                            >
                            
                            <template v-slot:filterPre>
                                <v-btn v-if="$vuetify.breakpoint.lgAndUp" outlined text class="ma-1 mr-0" color="primary" @click="goToToday">Today</v-btn>
                                <v-btn style="min-width:0px; max-width: 45px;" text class="ma-1 mr-0" color="primary" @click="prevDate()"><v-icon>mdi-chevron-left</v-icon></v-btn>
                                <v-menu v-model="mobileMenuDate" max-width="290" :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-if="$vuetify.breakpoint.smAndDown" class="ma-1 mr-1" color="primary" v-bind="attrs" v-on="on">{{ computedDateFormatted }}</v-btn>
                                        <v-btn v-else-if="$vuetify.breakpoint.mdOnly" class="ma-1 mr-1" color="primary" v-bind="attrs" v-on="on">{{ computedDateMediumFormatted }}</v-btn>
                                        <v-btn v-else class="ma-1 mr-1" color="primary" v-bind="attrs" v-on="on"><v-icon class="pr-2">mdi-calendar</v-icon>{{ computedDateLongFormatted }}</v-btn>
                                    </template>
                                    <v-date-picker
                                        v-model="reservation.startDate"
                                        @input="mobileMenuDate = false; startDateChanged()"
                                    ></v-date-picker>
                                </v-menu>
                                <v-btn style="min-width:0px; max-width: 45px;" text class="ma-1 ml-0 mr-1" color="primary" @click="nextDate()"><v-icon>mdi-chevron-right</v-icon></v-btn>
                                <v-btn class="ma-1" color="primary" @click="newReservation">Create</v-btn>
                                
                            </template>

                            <template v-slot:filterErrors>
                                <div class="pl-3" v-if="errorsSpace.length > 0" style="color:red; height:5px; margin-top: -20px;padding-right:25px; ">Please select a space below</div>
                                <div class="pl-3" v-if="errorsAllDay.length > 0" style="color:red; height:5px; margin-top: -20px;padding-right:25px; ">{{ errorsAllDay[0] }}</div>
                                <div class="pl-3" v-if="errorsTime.length > 0" style="color:red; height:5px; margin-top: -20px;padding-right:25px; ">{{ errorsTime[0] }}</div>
                            </template>
                            
                        </MitCalendarMultiSpaces>
                      </v-col>
                </v-row>
            </v-col>
          </v-row>
          
      </v-card>
  </div>
</template>

<script>
  import moment from 'moment';
  import BaseMitLoading from '../../base/components/BaseMitLoading.vue';
  import BaseMitDataTable from '../../base/components/BaseMitDataTable.vue';
  import BaseMitReserveEdit from '../../base/components/reserve/BaseMitReserveEdit.vue';
  import BaseMitReservationReadOnly from '../../base/components/reserve/BaseMitReservationReadOnly.vue';

  import BaseMitConfigService from '../../base/services/BaseMitConfigService.js';
  import MitReservationService from '../../base/services/BaseMitReserveService.js';
  import MitSpacesApiService from '../../base/services/BaseMitReserveSpacesService.js';
  import MitDateTimeService from '../../base/services/BaseMitReserveDateTimeService.js';

  import MitFavoritesService from '../services/MitFavoritesService.js';
  import MitCalendarMultiSpaces from './MitCalendarMultiSpaces.vue';
  import MitTimeSelect from './MitTimeSelect.vue';

export default {
  name: 'MitReserveSchedule',
  components: {
      BaseMitLoading,
      BaseMitDataTable,
      BaseMitReserveEdit,
      MitCalendarMultiSpaces,
      BaseMitReservationReadOnly,
      MitTimeSelect
  },
  props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
  },
  data: function() {
    return {
        dialog:false,
        dialogEdit:false,
        dialogSpaceDetails:false,
        dialogSpaceImages:false,
        dialogSelectedSpace:null,
        dialogExistingReservation:false,
        mobileMenuDate:false,
        hover:false,
        loadingSpaces:false,
        loadingReservations:true,
        loadingSave:false,
        loadingDelete:false,
        status:{
          display:false,
          timeout:3000,
          message:'Saved!',
          color:'primary'
        },
        isTimeValid:true,
        errorsSpace:[],
        errorsAllDay:[],
        errorsTime:[],
        dialogFilter:false,
        ui:{
            searchExpand:false,
            filterExpand:false,
            sortExpand:false
        },
        filterCapacity:0,
        filterEquipment:[],
        filterSpaceType:null,
        calendarColors:MitReservationService.getCalendarColors(),
        calEvents:[],
        calHoverEvent:{
            show:false,
            name: `Reservation`,
            color: '#2196F3',
            category: '',
            start: null,
            end: null,
            timed: true
        },
        calCurrentReservation:{
            show:false,
            name: 'Reservation',
            category: '',
            color: '',
            start: null,
            end: null,
            timed: true,
            potential:true //indicate that this is the potential event
        },
        calSelectedEvent:null,
        spacesUrl:null,
        spaces:[],
        spaceInfo:{},
        selectedSpace:null,
        spaceSearch:'',
        spaceTypes:[{text:'Conference Room',id:'conference'},{text:'Phonebooth',id:'phonebooth'}],
        spacesEquipment:[],
        reservationsExisting:[],
        selectedReservationExisting:null,
        selectedReservationExistingId:null,
        reservation:{
            name:'',
            description:'',
            allDay:false
        },
        // dateTime:{
        //     startDate:null,
        //     startTime:null,
        //     duration:null,
        //     allDay:false
        // },
        recurring:{
            repeats:false,
            repeatsUntilDate: moment().add(1,'year').format('YYYY-MM-DD'),
            repeatChoice:'weekly',
            repeatOptions:[
                {text:'Does Not Repeat',value:'none'},
                {text:'Daily',value:'daily'},
                {text:'Weekly',value:'weekly'},
                {text:'Monthly',value:'monthly'}
            ],
            days:{
                monday:true,
                tuesday:true,
                wednesday:true,
                thursday:true,
                friday:true,
                saturday:false,
                sunday:false
            },
        },
        dateStartMenu:false,
        focus:null,
        duration:60,
        defaultTimes:null,
        startTime:null,
        timeList:[],
        dateTimeService: new MitDateTimeService()
    }
  },
  created(){
      this.timeList = this.dateTimeService.getTimes();
      this.createReservationModel();

      this.requestGetSpaces();
  },
  computed: {
      computedDateMediumFormatted(){
        return this.reservation.startDate ? moment(this.reservation.startDate).format('MMMM D YYYY') : ''
      },
      computedDateFormatted () {
        return this.reservation.startDate ? moment(this.reservation.startDate).format('MMM D YYYY') : ''
      },
      computedDateLongFormatted () {
        return this.reservation.startDate ? moment(this.reservation.startDate).format('ddd,  MMMM DD YYYY') : ''
      },
      getView () {
        
        if(this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm')
            return 'mobile-sm'

        if(this.$vuetify.breakpoint.name === 'md' || this.$vuetify.breakpoint.name === 'lg')
            return 'mobile-md'

        return 'desktop'
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm' || this.$vuetify.breakpoint.name === 'md';
      }
  },
  mounted() {
      this.requestGetExistingReservations();
      this.spacesUrl = BaseMitConfigService.get('CLIENT_API_SPACES');
      // this.$refs.calMultiSpaces.setFocusTimeNow();
  },
  methods : {
      showExistingReservationDetails(existingReservation){
        this.selectedReservationExisting = existingReservation;
        if(MitReservationService.hasEditRights(existingReservation, this.userModel.csailId)){
            this.selectedReservationExistingId = this.selectedReservationExisting.uniqueId;
            this.dialogEdit = true;
        }
        else{
            this.dialogExistingReservation = true;
        }
        
      },
      showSpaceImages(space){
            this.dialogSelectedSpace = space;
            this.dialogSpaceImages = true;
      },
      showSpaceDetails(space){
            this.dialogSelectedSpace = space;
            this.dialogSpaceDetails = true;
      },
      favoriteChanged(space){
        if(space.favorite){
            space.favorite = false;
            MitFavoritesService.delete(space.mitId)
            .then((data) => {})
            .catch((error) => {
                this.status.message = 'An error removing favorite '+mitId;
                this.status.display = true;
                this.status.color = 'red';
                console.log('ERROR:', error);
            });
            
        }
        else{
            space.favorite = true;
            MitFavoritesService.save(space.mitId)
                .then((data) => {})
                .catch((error) => {
                    this.status.message = 'There was an error adding favorite '+ mitId;
                    this.status.display = true;
                    this.status.color = 'red';
                    console.log('ERROR:', error);
                });
        }
      },
      resetForm(){
        this.selectedSpace = null;
        this.errorsSpace = [];
        this.errorsAllDay = [];
        this.errorsTime = [];

        this.createReservationModel();
        this.requestGetExistingReservations();
      },
      requestGetExistingReservations(){
          this.loadingReservations = true;

          let startUTC = moment(this.reservation.startDate, 'YYYY-MM-DD').startOf('day').subtract(24,'h').utc().format('YYYY-MM-DD hh:mm A');
          let endUTC = moment(this.reservation.endDate, 'YYYY-MM-DD').endOf('day').add(24,'h').utc().format('YYYY-MM-DD hh:mm A');
          return new Promise ((resolve, reject) => {

            MitReservationService.getExistingReservations(startUTC, endUTC)
                .then((data) => {
                    this.reservationsExisting = data.reservations;
                    this.calEvents.splice(0, this.calEvents.length);

                    let event;
                    for(let x = 0; x < this.reservationsExisting.length; x++){
                        event = {
                            name: this.reservationsExisting[x].name || 'Reserved',
                            category:this.reservationsExisting[x].mitId,
                            start: this.reservationsExisting[x].startDateTime.toDate(),
                            end: this.reservationsExisting[x].endDateTime.toDate(),
                            startString: this.reservationsExisting[x].startDateTime.format("h:mm A"),
                            endString: this.reservationsExisting[x].endDateTime.format("h:mm A"),
                            color: this.calendarColors.event,
                            timed: true,
                            reservationModel:this.reservationsExisting[x]
                        };

                        if(MitReservationService.isOwner(this.reservationsExisting[x], this.userModel.csailId)){
                            event.color = this.calendarColors.myEvent;
                        }
                        else if(MitReservationService.isSecondaryOwner(this.reservationsExisting[x], this.userModel.csailId)){
                            event.color = this.calendarColors.mySecondaryEvent;
                        }
                        this.calEvents.push(event);
                    }
                    this.calEvents.push(this.calCurrentReservation);

                    this.loadingReservations = false;

                    resolve(this.reservationsExisting);
                })
                .catch((error) => {
                    this.loadingReservations = false;
                    this.status.message = 'An error occurred trying to get the reservations for spaces';
                    this.status.display = true;
                    this.status.color = 'red';

                    console.log('ERROR:', error);
                });
            });
      },
      requestGetSpaces(){
          this.loadingSpaces = true;

          return MitSpacesApiService.getReservableSpaces()
            .then((data) => {
                this.spaces = data.spaces;
                this.spaceInfo = MitSpacesApiService.getSpaceStats(this.spaces);
                this.loadingSpaces = false;
            })
            .catch((error) => {
                this.loadingSpaces = false;
                this.status.message = 'An error occurred trying to get spaces';
                this.status.display = true;
                this.status.color = 'red';

                console.log('ERROR:', error);
            });
      },
      createReservationModel(){

            let newReservationModel = MitReservationService.create();

            if(this.reservation && this.reservation.startDate){
                //if we had one already, lets keep the current dates the same, most likely
                //users will want to stay where they are and create a bunch
                newReservationModel.startDate = this.reservation.startDate;
                newReservationModel.endDate = this.reservation.endDate;
            }
            
            this.reservation = newReservationModel;
            // MitReservationService.set(this.reservation);

            this.updateCurrentReservationStartEnd(this.reservation);
            this.checkForConflics(this.reservation, this.reservationsExisting)
      },
      updateCurrentReservationStartEnd(reservation){

          this.reservation = MitReservationService.updateDateTime(reservation);

          this.calCurrentReservation.name = this.reservation.name;
          this.calCurrentReservation.category = this.reservation.mitId;
          this.calCurrentReservation.start = this.reservation.startDateTime.toDate();
          this.calCurrentReservation.end = this.reservation.endDateTime.toDate();
          this.calCurrentReservation.reservationModel = this.reservation;
          this.calCurrentReservation.color = this.calendarColors.potentialEvent;
          

      },
      dateRangeStartConflict(moment1Start, moment2End){
        return (moment1Start < moment2End)
      },
      dateRangeEndConflict(moment1End, moment2Start){
        return (moment2Start < moment1End)
      },
      getSuggestedReservationStartEnd(target_mit_id, potential_start,potential_end, existingReservations){
        let result = {
            startMoment:potential_start,
            endMoment:potential_end
        }

        let existingResForSpace = existingReservations.filter(x => x.mitId === target_mit_id);
        for(let x = 0; x < existingResForSpace.length; x++){
            //START CONFLICT: Only conflicting with the target reservation end time
            if(potential_start < existingResForSpace[x].endDateTime && potential_start > existingResForSpace[x].startDateTime){
                result.startMoment = new moment(existingResForSpace[x].endDateTime);
            }
            //END CONFLICT: Only conflicting with the target reservation end time
            if(potential_end > existingResForSpace[x].startDateTime && potential_end < existingResForSpace[x].endDateTime){
                result.endMoment = new moment(existingResForSpace[x].startDateTime);
            }
        }
        return result;
        
      },
      checkForConflics(reservation, existingReservations){
        //Check for conflicts
          //get only the current mitId reservations
          let existingResForSpace = existingReservations.filter(x => x.mitId === reservation.mitId);
          if(this.dateTimeService.checkDateConfictsInReservations(existingResForSpace, reservation.startDateTime, reservation.endDateTime)){
              this.isTimeValid = false;
              this.calCurrentReservation.color = 'red';
          }
          else{
              this.isTimeValid = true;
              this.calCurrentReservation.color = this.calendarColors.potentialEvent;
          }
      },
      goToToday(){
        this.reservation.startDate = new moment().format("YYYY-MM-DD");
        this.startDateChanged();
      },
      prevDate(){
        this.reservation.startDate = new moment(this.reservation.startDateTime).subtract(1, 'days').format("YYYY-MM-DD");
        this.startDateChanged();
      },
      nextDate(){
        this.reservation.startDate = new moment(this.reservation.startDateTime).add(1, 'days').format("YYYY-MM-DD");
        this.startDateChanged();
      },
      startDateChanged(){
          //if we are doing duration adn not showing date end then lets also update the end date so they stay in sync
          this.reservation.endDate = this.reservation.startDate;

          this.updateCurrentReservationStartEnd(this.reservation);

          this.checkForConflics(this.reservation, this.reservationsExisting);

          this.requestGetExistingReservations()
                .then((existingReservations) => {
                    this.checkForConflics(this.reservation, this.reservationsExisting);
                    // this.isFormValid();
                });
      },
      startTimeChanged(time){

        this.updateCurrentReservationStartEnd(this.reservation);
        this.checkForConflics(this.reservation, this.reservationsExisting);

        this.isFormValid();

      },
      endTimeChanged(time){
        this.updateCurrentReservationStartEnd(this.reservation);
        this.checkForConflics(this.reservation, this.reservationsExisting);

        this.isFormValid();
      },
      spaceFavoriteClick(space){
          let s = this.spaces.find(x => x.mitId === space.mitId);
          s.favorite = !s.favorite;
      },
      calendarChange(event){
        //Get teh duration from the start and end time, we dont' want to pin the end time, we want the duration is what matters to the user
        //  let duration = moment.duration(this.reservation.endDateTime.diff(this.reservation.startDateTime)).asMinutes();
        let duration = 60;
        
        
        //Get the duration of the new start time clicked by the calendar, to end of day to make sure we are not running past end of day
        //  let endOfDay = new moment(event.datetimeMoment).endOf('day');
        //  let durationToEndOfDay = moment.duration(endOfDay.diff(event.datetimeMoment)).asMinutes();
        //  durationToEndOfDay = Math.round(durationToEndOfDay);


         this.reservation.mitId = event.mitId;
        //  this.reservation.startTime = event.time;

         
         //set the time of this event to the end of the day if the end time goes past into the next day
        //  if(duration > durationToEndOfDay){
        //     duration = durationToEndOfDay - 15;
        //  }

         //Check if we need to shrink the time to less than one hour to fit between reservations
         let potentialStartMoment = new moment(event.datetimeMoment);
         let potentialEndMoment = new moment(event.datetimeMoment).add(duration, 'minutes');

         let suggestions = this.getSuggestedReservationStartEnd(event.mitId, potentialStartMoment, potentialEndMoment,this.reservationsExisting);
         this.reservation.startTime = suggestions.startMoment.format(MitReservationService.defaultTimeFormat);
         this.reservation.endTime = suggestions.endMoment.format(MitReservationService.defaultTimeFormat);
        //  let durationMinutesUntilNext = moment.duration(potentialEndMoment.diff(nextReservation.startDateTime)).asMinutes()
        //  totalConflict:false,
        //     startMomentConflict:null,
        //     endMomentConflict:null
        // this.reservation.startTime = event.time;
        //  let durationMinutesUntilNext = 0;
        //  if(conflicts.totalConflict === false){
        //     if(conflicts.startMomentConflict)
        //     durationMinutesUntilNext = moment.duration(potentialEndMoment.diff(nextReservation.startDateTime)).asMinutes()
        //  }

        //  let dateTimeEnd;
        //  if(nextReservation && durationMinutesUntilNext > 15 && durationMinutesUntilNext < 60){
        //     dateTimeEnd = new moment(event.datetimeMoment).add(durationMinutesUntilNext, 'minutes');
        //  }
        //  else{
        //     dateTimeEnd = new moment(event.datetimeMoment).add(duration, 'minutes');
        //  }

         
        //  console.log('TEST TEST: ', durationMinutesUntilNext)
        //  console.log('Next Res: ', nextReservation)
        //  if(nextReservation)
        //     console.log('Next Res Start: ', nextReservation.startDateTime.format('HH:mm'))
        //  console.log('event.mitId: ', event.mitId)
        //  console.log('start: ', potentialStartMoment.format('HH:mm'))
        //  console.log('end: ',potentialEndMoment.format('HH:mm'))
        //  console.log('this.reservationsExisting: ', this.reservationsExisting)
         //Create the moment end date now
        //  let dateEnd = new moment(event.datetimeMoment);
        //  dateEnd.set({
        //     hour:   dateTimeEnd.get('hour'),
        //     minute: dateTimeEnd.get('minute'),
        //     second: dateTimeEnd.get('second')
        //  });
        //  this.reservation.endTime = dateEnd.format(MitReservationService.defaultTimeFormat);

         this.selectedSpace = this.spaces.find(x => x.mitId === event.mitId);

         this.updateCurrentReservationStartEnd(this.reservation);
         this.checkForConflics(this.reservation, this.reservationsExisting)
        //  this.isFormValid();
     },
     newReservation(){
        this.dialog = true;     
     },
     cancelReservation(){
        this.dialog = false;
        this.dialogEdit = false;
        this.resetForm();
     },
     deleteReservation(reservation){
        this.dialog = false;
        this.dialogEdit = false;
        this.loadingDelete = true;

        MitReservationService.delete(reservation.uniqueId)
              .then((data) => {
                  this.loadingDelete = false;

                  if(data.numDeleted <= 0){
                      this.status.message = 'Could not delete reservation or reservation was already deleted.';
                      this.status.color = 'red';
                      this.status.display = true;
                  }
                  else{
                      this.status.message = 'Deleted Reservation.',
                      this.status.color = 'primary'
                      this.status.display = true;
                  }
                  this.resetForm();//reset the form values to potentially start over
              })
              .catch((error) => {
                  this.loadingDelete = false;
                  this.status.message = 'An error occurred trying to get delete the reservation.';
                  this.status.display = true;
                  this.status.color = 'red';
                  console.log('ERROR:', error);
                  this.resetForm();//reset the form values to potentially start over
              });

     },
     saveReservation(reservation){
          this.loadingSave = true;

          MitReservationService.save(reservation)
            .then((data) => {
                this.loadingSave = false;
                this.status.message = 'Saved!',
                this.status.color = 'primary'
                this.status.display = true;
                this.dialog = false;
                this.dialogEdit = false;
                this.resetForm();//reset the form values to potentially start over
            })
            .catch((error) => {
                this.loadingSave = false;
                this.dialog = false;
                this.dialogEdit = false;
                this.status.message = error;
                this.status.display = true;
                this.status.color = 'red';
                this.errorsSpaces = ['Error getting available spaces from space app.']
                console.log('ERROR:', error);
                this.resetForm();//reset the form values to potentially start over
            });
      }

  }
}
</script>

<style lang="scss" scoped>
    .scrollable-list{
        height:200px;/* or any height you want */
        overflow-y:auto
    }
    .v-select.fit {
    width: min-content;
    }
    .v-select.fit  .v-select__selection--comma {
        text-overflow: unset;
    }
    // important to hide the day/date info since we don't need it
    ::v-deep .v-calendar-daily_head-weekday {
        display: none;
    }
    ::v-deep .v-calendar-daily_head-day-label {
        display: none;
    }
    // ::v-deep .v-date-picker-header__value{
    //     font-size: 23px;
    // }
    // ::v-deep .v-date-picker-header{
    //     .v-date-picker-header__value{
    //         font-size: 20px;
    //     }
    //     // .v-icon{
    //     //     font-size:30px !important;
    //     // }
        
    // }
</style>
